import React from 'react';
import ComparisonRow from '../../components/pages/comparison/ComparisonRow';

const ComparisonRows = ({ entities, sharedMode }) => (
	<div className="comparison-rows">
		<ComparisonRow entities={entities} metric="artists" sharedMode={sharedMode} />
		<ComparisonRow entities={entities} metric="products" sharedMode={sharedMode} />
		<ComparisonRow entities={entities} metric="tracks" sharedMode={sharedMode} />
		<ComparisonRow entities={entities} metric="territories" sharedMode={sharedMode} />
		<ComparisonRow entities={entities} metric="vendors" sharedMode={sharedMode} />
	</div>
);

export default ComparisonRows;